import { render, staticRenderFns } from "./ReplyPopup.vue?vue&type=template&id=07279712&scoped=true"
import script from "./ReplyPopup.vue?vue&type=script&lang=js"
export * from "./ReplyPopup.vue?vue&type=script&lang=js"
import style0 from "./ReplyPopup.vue?vue&type=style&index=0&id=07279712&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07279712",
  null
  
)

export default component.exports